export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
  },
  title: 'What retailer did you place the order with?',
  placeholderText: 'e.g. Currys, Amazon',
}
